import React from "react";
import Nav from "../../components/Navbar/Nav";
import "./Profile.css";
import { useSelector } from "react-redux";
import { selectUser } from "./../../features/userSlice";
import { auth } from "../../firebase";

function Profile() {
	const user = useSelector(selectUser);

	return (
		<div className="profile">
			<Nav />
			<div className="profile__content">
				<h1 className="profile__title">Edit Profile</h1>
				<div className="profile__card">
					<img
						className="profile__avatar"
						src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png?20201013161117"
						alt="Profile avatar"
					/>
					<div className="profile__details">
						<div className="profile__email">{user?.email}</div>
						<div className="profile__plans">
							<h3>Plan: Premium</h3>
						</div>
						<button
							onClick={() => auth.signOut()}
							className="profile__signout"
						>
							Sign Out
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Profile;
